import { ListAlt } from '@mui/icons-material'
import VirtualSectionCreate from './VirtualSectionCreate'
import VirtualSectionEdit from './VirtualSectionEdit'
import VirtualSectionList from './VirtualSectionList'

const virtualSectionIndex = {
  icon: ListAlt,
  list: VirtualSectionList,
  edit: VirtualSectionEdit,
  create: VirtualSectionCreate,
}

export default virtualSectionIndex
